module.exports = __webpack_public_path__ + "assets/icons/pickup-location.png";


//////////////////
// WEBPACK FOOTER
// ./src/styles/icons/pickuplocation/pickup-location.png
// module id = ./src/styles/icons/pickuplocation/pickup-location.png
// module chunks = 0